/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-unused-state */
/* eslint-disable camelcase */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';

import Select2, { DataSelect2 } from 'wdna-select2';
import DatePicker, { DateSelectorConfig } from 'wdna-date-selector';

import { GridApi, RowDataUpdatedEvent, GridReadyEvent, ICellRendererParams } from 'wdna-grid-table/lib/types';
import Table, { TableButtonsConfig } from 'wdna-components/lib/table/Table';
import { TabConfig, addTab, removeTab } from 'wdna-components/lib/tabs';
import { messageInfo, messageError, messageWarning, messageBoxText, messageBoxInfo } from 'wdna-components/lib/helpers/notification';
import { getErrorMessage } from 'wdna-components/lib/helpers/response';
import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';
import { hasLevel } from 'wdna-components/lib/helpers/permission-new';

import { sensor, SensorDO } from '../../requests';

import Adjustments from './adjustments/List';
import Readings from '../Readings';
import Graphs from '../Graphs';
import SensorsEdit from './Edit';

const ALERTS: string[] = ['TIMESTAMP', 'FIRE', 'BATTERY', 'RSSI', 'MALFUNTION'];

type Props = unknown;

interface State {
  loading: boolean;
  update: string;
  marked: number;
  id_src: string;
  id_dst: string;
  modalContent: string;

  showGrid: boolean;
  showSelector: boolean;
  showNominal: boolean;
  showMigrateRegister: boolean;

  dates: Date[];
  flatpickrMode: string;
  groupDateTime: string;
  dateIni: string;
  timeIni: string;
  dateEnd: string;
  timeEnd: string;

  status?: string;

  data: SensorDO[];
}

export default class List extends React.Component<Props, State> {
  private pid: any;
  private mounted: boolean;
  private userIsADM: boolean;
  private buttons: TableButtonsConfig;
  private gridApi: GridApi | undefined;

  public constructor(props: Props) {
    super(props);

    this.pid = window.getStr();
    this.mounted = false;
    this.userIsADM = false;

    const dIni: Date = new Date();
    dIni.setDate(dIni.getDate() - 2);
    const dEnd: Date = new Date();

    this.buttons = {
      // toolbar
      add: hasLevel('role', ['ADM', 'URW']),
      pCustom: [true, true, false],
      // actions
      edit: true,
      copy: hasLevel('role', ['ADM', 'URW']),
      del: hasLevel('role', ['ADM', 'URW']),
      graph: true,
      list: true,
      list2: true,
      labels: {
        graph: 'Readings',
        list: 'Readings',
        list2: 'Adjustments',
        pCustom: [
          'Readings',
          'Nominal Plan',
          'Migrate Register'
        ]
      }
    };

    this.state = {
      loading: false,
      update: window.getStr(),
      data: [],
      marked: 0,
      id_src: '',
      id_dst: '',
      modalContent: '',

      showGrid: false,
      showSelector: false,
      showNominal: false,
      showMigrateRegister: false,

      dates: this.initialDates(),
      flatpickrMode: 'range',
      groupDateTime: '24h',
      dateIni: moment(dIni).add(1, 'days').format('YYYY-MM-DD'),
      timeIni: '00:00',
      dateEnd: moment(dEnd).add(1, 'days').format('YYYY-MM-DD'),
      timeEnd: '00:00',
    };
  }

  public componentDidMount(): void {
    this.mounted = true;
    this.userIsADM = hasLevel('role', ['ADM']);

    this.load();
  }

  public shouldComponentUpdate(nextProps: Props, nextState: State): boolean {
    return this.state.update !== nextState.update;
  }

  public componentWillUnmount(): void {
    this.mounted = false;
  }

  public setLocalState = (nextState: Partial<State>, callback?: (() => void)): void => {
    if (this.mounted) {
      this.setState((prevState: State) => ({
        ...prevState,
        ...nextState,
      }), callback);
    }
  };

  public load = (): void => {
    this.loadingStart();
    sensor<SensorDO[]>('list')
      ?.then((resp: SensorDO[]) => {
        this.setLocalState({ data: resp });
      })
      .catch((error: any) => {
        messageError('Error', getErrorMessage(error));
      })
      .finally(() => {
        this.loadingFinish();
      });
  };

  public initialDates = (): Date[] => {
    const today: Date = new Date();
    const twoDaysBefore: Date = moment().add(-2, 'days').toDate();
    return [twoDaysBefore, today];
  };

  public loadingStart = (): void => {
    this.setLocalState({
      update: window.getStr(),
      loading: true,
    });
  };

  public loadingFinish = (): void => {
    this.setLocalState({
      update: window.getStr(),
      loading: false,
    });
  };

  public loadTab = (rowId: number, duplicate: boolean): void => {
    const tabId: string = 'SE';
    let title: string = rowId ? `Sensor Edit: ${rowId}` : 'Sensor New';
    if (duplicate) title = `Sensor Duplicate: ${rowId}`;

    window.store.dispatch(removeTab(tabId));
    const tabData: TabConfig = {
      id: tabId,
      active: true,
      title,
      component: SensorsEdit,
      props: {
        rowId,
        tabId: this.pid,
        report: 'SENSORS',
        title: 'Sensors',
        notify: this.notify,
        sensorList: this.state.data,
        duplicate
      },
    };
    window.store.dispatch(addTab(tabData));
  };

  public showModalUpdate = (): void => {
    this.setLocalState({
      update: window.getStr(),
      showSelector: true,
    });
  };

  public onClose1 = (): void => {
    this.setLocalState({
      update: window.getStr(),
      showSelector: false,
    });
  };

  public onClose2 = (): void => {
    this.setLocalState({
      update: window.getStr(),
      showNominal: false,
    });
  };

  public onClose3 = (): void => {
    this.setLocalState({
      update: window.getStr(),
      showMigrateRegister: false,
    });
  };

  public resetModal = (): void => {
    this.setLocalState({
      update: window.getStr(),
      status: '',
      marked: 0,
    });
  };

  public notify = (): void => {
    this.load();
  };

  public onEdit = (item: SensorDO): void => {
    window.store.dispatch(removeTab('SE'));
    const rowId: number = item.id;
    setTimeout(() => {
      this.loadTab(rowId, false);
    }, 0);
  };

  public onCopy = (item: SensorDO): void => {
    window.store.dispatch(removeTab('SE'));
    const rowId: number = item.id;
    setTimeout(() => {
      this.loadTab(rowId, true);
    }, 0);
  };

  public onDelete = (item: SensorDO): void => {
    const confirm: string = String(item.code);
    messageBoxText('Delete', `Enter '${confirm}' to confirm you want to delete the item: ${item.name}?`, (value?: string) => {
      if (confirm === value) {
        this.loadingStart();
        sensor('del', String(item.id))
          ?.then(() => {
            messageInfo('Success', 'Register successfully deleted', 5000);
            this.load();
          })
          .catch((error: any) => {
            messageError('Error', getErrorMessage(error));
          })
          .finally(() => {
            this.loadingFinish();
          });
      } else {
        messageWarning('Warning', 'Wrong input parameter', 5000);
      }
    }, 'remove-circle', undefined, confirm);
  };

  public onGraph = (item: SensorDO): void => {
    window.store.dispatch(removeTab('GRH'));
    const id: number = item.id;
    const code: string = item.code;
    setTimeout(() => {
      this.loadGraph(id, code);
    }, 0);
  };

  public loadGraph = (id: number, code: string): void => {
    const tabId: string = 'GRH';
    const title: string = id ? `Sensor Graphs: ${id} - ${code}` : 'Total Graphs';
    const tabData: TabConfig = {
      id: tabId,
      active: true,
      title,
      component: Graphs,
      props: {
        rowId: id,
        code,
        report: 'SENSORS GRAPHS',
        title: 'Sensors Graphs',
        tabId: this.pid,
      },
    };
    window.store.dispatch(addTab(tabData));
  };

  public onList = (item: SensorDO): void => {
    window.store.dispatch(removeTab('RED'));
    const id: number = item.id;
    const code: string = item.code;
    setTimeout(() => {
      this.loadList(id, code);
    }, 0);
  };

  public loadList = (id?: number, code?: string): void => {
    const tabId: string = 'RED';
    const title: string = id ? `Sensor Reads: ${id} - ${code}` : 'Total Reads';
    const tabData: TabConfig = {
      id: tabId,
      active: true,
      title,
      component: Readings,
      props: {
        code,
        rowId: id,
        report: 'SENSOR READS',
        title: 'Sensor Reads',
        tabId: this.pid,
      },
    };
    window.store.dispatch(addTab(tabData));
  };

  public loadList2 = (rowId: number): void => {
    const tabId: string = 'ADJ';
    const tabData: TabConfig = {
      id: tabId,
      active: true,
      title: `Adjustments | Sensor ID: ${rowId}`,
      component: Adjustments,
      props: {
        rowId,
        tabId: this.pid,
        report: 'SENSOR ADJUSTMENTS',
        title: 'Sensor Adjustments',
      },
    };
    window.store.dispatch(addTab(tabData));
  };

  public onPCustom1 = (): void => {
    window.store.dispatch(removeTab('RED'));
    setTimeout(() => {
      this.loadList();
    }, 0);
  };

  public onPCustom2 = (): void => {
    this.setLocalState({
      update: window.getStr(),
      showNominal: true,
    });
  };

  public onPCustom3 = (): void => {
    this.setLocalState({
      update: window.getStr(),
      showMigrateRegister: true,
    });
  };

  public onList2 = (value: SensorDO): void => {
    window.store.dispatch(removeTab('ADJ'));
    const rowId: number = value.id;
    setTimeout(() => {
      this.loadList2(rowId);
    }, 0);
  };

  public rowDataUpdated = (_event: RowDataUpdatedEvent): void => {
    this.setLocalState({
      update: window.getStr(),
      showGrid: true,
    });
  };

  public handleSelect = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const { value, name } = e.target;
    this.setLocalState({
      update: window.getStr(),
      [name]: value,
    });
  };

  public countSelected = (): void => {
    let marked: number = 0;
    if (this.gridApi) {
      marked = this.gridApi.getSelectedNodes().length;
    }
    this.setLocalState({
      update: window.getStr(),
      marked,
    });
  };

  public onSave = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    messageBoxInfo('Update', 'Are you sure you want change status the selected sensors?', () => {
      this.bulkActivation(this.state.status);
      this.onClose1();
      this.resetModal();
    });
  };

  public alertsCellRenderer = (params: ICellRendererParams): React.ReactNode => {
    let { value } = params;

    const result: JSX.Element[] = [];
    if (params.data.status === 'ON_AIR' && value !== null && String(value).length > 4) {
      value = String(value);
      ALERTS.forEach((item: string, idx: number) => {
        const color: string = (value[idx] === '0' ? 'green' : 'red');
        result.push(<i className="fa fa-circle" style={{ color }} title={item} />);
      });
    } else {
      ALERTS.forEach((item: string) => {
        result.push(<i className="fa fa-circle" style={{ color: 'gray' }} title={item} />);
      });
    }

    return <div>{result}</div>;
  };

  public checkNocxCellRenderer = (params: ICellRendererParams): React.ReactNode => {
    let color: string = 'gray';
    if (params.data.status === 'ON_AIR') {
      const { value } = params;
      color = (value ? 'red' : 'green');
    }

    return <i className="fa fa-circle" style={{ color }} />;
  };

  // TODO: generic ??
  public listCellRenderer = (params: ICellRendererParams): React.ReactNode => {
    const { value } = params;
    if (_.isArray(value)) {
      const style: React.CSSProperties = {
        backgroundColor: '#064754', borderRadius: '4px', padding: '3px 5px', margin: '2px',
      };
      const result: JSX.Element[] = value.map((item: string): JSX.Element => {
        return <span style={style}>{item}</span>;
      });

      return _.isEmpty(result) ? '' : <div>{result}</div>;
    }

    return value || '';
  };

  public bulkActivation = (status: any): void => {
    if (this.gridApi) {
      const selectedNodes: any[] = this.gridApi.getSelectedNodes();
      const data: SensorDO[] = selectedNodes.map((row: any) => { return row.data.id; });

      this.loadingStart();
      sensor('update', undefined, data, { params: { status } })
        ?.then((resp: any) => {
          messageInfo('Success', resp.message, 5000);
          this.load();
        })
        .catch((error: any) => {
          messageError('Error', getErrorMessage(error));
        })
        .finally(() => {
          this.loadingFinish();
        });
    }
  };

  public dateCellRenderer = (params: ICellRendererParams): React.ReactNode => {
    let { value } = params;
    if (value) {
      [value] = value.split(' ');
    }
    return value;
  };

  public onGridReady = (event: GridReadyEvent): void => {
    // map the api
    this.gridApi = event.api;
  };

  public convertNumber = (): void => {
    if (this.state.data !== undefined) {
      for (let i: number = 0; i < this.state.data.length; i++) {
        Number(this.state.data[i].code);
      }
    }
  };

  public handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>): void => {
    const { name, value, checked, type, dataset } = (e as React.ChangeEvent<HTMLInputElement>).target;
    const { ctype } = dataset || {};
    // Process new value from ctype
    let newValue: any = (type === 'checkbox') ? !!checked : value;
    if (ctype === 'number') newValue = (/^\d+(\.\d+){0,1}$/.test(value)) ? _.toNumber(value) : null;
    // Create new data state structure
    const levels: string[] = name.split('.');
    const nextState: Record<string, any> = { [levels[0]]: { ...this.state[levels[0]] } };
    _.set(nextState, levels, newValue);
    nextState.update = window.getStr();
    this.setLocalState(nextState);
  };

  public handleChangeDatePicker = (config: DateSelectorConfig): void => {
    const { flatpickrMode } = this.state;

    const hours: string[] = config.getHours() as string[];
    const dates: Date[] = config.getDates() as Date[];
    const newDataIni: moment.Moment = moment(dates[0]);
    const newDataEnd: moment.Moment = (flatpickrMode === 'range') ? moment(dates[1]) : moment(newDataIni).add(1, 'days');

    this.setLocalState({
      dates,
      timeIni: hours[0],
      timeEnd: hours[1],
      dateIni: newDataIni.format('YYYY-MM-DD'),
      dateEnd: newDataEnd.format('YYYY-MM-DD'),
      flatpickrMode: config.getMode(),
    });
  };

  public migrateRegisters = async (): Promise<void> => {
    const { id_src, id_dst, dates } = this.state;

    this.loadingStart();
    try {
      const sensorInfoSrc: SensorDO | undefined = await sensor<SensorDO>('get', id_src);
      const sensorInfoDst: SensorDO | undefined = await sensor<SensorDO>('get', id_dst);
      const typeSensorIdSrc: number | undefined = sensorInfoSrc?.typeSensorId;
      const typeSensorIdDst: number | undefined = sensorInfoDst?.typeSensorId;
      if (!_.isNil(typeSensorIdSrc) && typeSensorIdSrc === typeSensorIdDst) {
        // TODO: normalize dates ??
        const req: Record<string, any> = { id_src, id_dst, from: dates[0], to: dates[1] };
        const res: any = await sensor('copy', undefined, req);
        this.setLocalState({ modalContent: res });
        messageInfo('Success', 'Transfer register OK', 5000);
      } else {
        messageError('Error', 'Typse sensor is diferent');
      }
    } catch (error) {
      messageError('Error', getErrorMessage(error));
    }
    this.loadingFinish();
  };

  public render(): JSX.Element {
    const { loading, showSelector, showNominal, showGrid, showMigrateRegister } = this.state;
    const { dates, flatpickrMode, groupDateTime, id_src, id_dst, data, modalContent, marked, status } = this.state;

    if (this.userIsADM && this.buttons.pCustom) this.buttons.pCustom[2] = true;

    this.convertNumber();

    const columnAlias: Record<string, string> = {
      selectedRow: ' ',
      id: 'ID',
      code: 'Code',
      status: 'Status',
      name: 'Name',
      description: 'Description',
      lastDate: 'Last-DATE',
      lastAdrs: 'Last-ADRS',
      lastGateway: 'Last-GTWY',
      checkNocx: 'NCX',
      companyName: 'Company',
      locationName: 'Location',
      typeSensorName: 'Sensor type',
      alarm: 'ALA',
      adjusted: 'ADJ',
      alerts: 'Alerts',
      latitude: 'Latitude',
      longitude: 'Longitude',
      dateInstall: 'Date Install',
      dateOnline: 'Date Online',
      dateOffline: 'Date Offline',
      dateAction: 'Date Last-Action',
      sim: 'SIM Code',
      router: 'Router Code',
      companyType: 'Company Type',
      companyContact: 'Contact',
      companyPhone: 'Phone',
      companyEmail: 'E-mail',
      comments: 'Comments',
      groupsList: 'Groups',
    };

    const columnsToHide1: string[] = [
      'lastTmsp',
      'checkTmsp',
      'command1',
      'command2',
      'command3',
      'update',
      'persistent1',
      'persistent2',
      'companyId',
      'firmwareId',
      'firmwareVer',
      'firmwareFile',
      'typeSensorId',
      'locationId',
      'latitude',
      'longitude',
      'nocxTime',
      'alarm',
      'adjusted',
      'dateInstall',
      'dateOnline',
      'dateOffline',
      'dateAction',
      'sim',
      'router',
      'comments',
      'companyType',
      'companyContact',
      'companyPhone',
      'companyEmail',
      'nocxTimetable',
      'lastAdrs',
    ];
    const columnsToHide2: string[] = [
      'id',
      'checkTmsp',
      'command1',
      'command2',
      'command3',
      'update',
      'persistent1',
      'persistent2',
      'companyId',
      'firmwareId',
      'firmwareVer',
      'firmwareFile',
      'typeSensorId',
      'locationId',
      'nocxTime',
      'alarm',
      'adjusted',
      'lastTmsp',
      'lastDate',
      'lastAdrs',
      'lastGateway',
      'checkNocx',
      'alerts',
      'nocxTimetable',
      'groupsList'
    ];
    const columnStyles: Record<string, any> = {
      id: { textAlign: 'right' },
      code: { textAlign: 'right' },
      status: { textAlign: 'center' },
      name: { textAlign: 'left' },
      description: { textAlign: 'left' },
      lastDate: { textAlign: 'center' },
      lastAdrs: { textAlign: 'center' },
      lastGateway: { textAlign: 'right' },
      checkNocx: { textAlign: 'center' },
      companyName: { textAlign: 'left' },
      locationName: { textAlign: 'left' },
      typeSensorName: { textAlign: 'left' },
      alarm: { textAlign: 'center' },
      adjusted: { textAlign: 'center' },
      alerts: { textAlign: 'center', type: 'abool' },
      dateInstall: { textAlign: 'center' },
      dateOnline: { textAlign: 'center' },
      dateOffline: { textAlign: 'center' },
      dateAction: { textAlign: 'center' },
      sim: { textAlign: 'left' },
      router: { textAlign: 'left' },
      companyType: { textAlign: 'left' },
      companyContact: { textAlign: 'left' },
      companyPhone: { textAlign: 'left' },
      companyEmail: { textAlign: 'left' },
      comments: { textAlign: 'left' },
      groupsList: { textAlign: 'left' },
      actionButtons: { textAlign: 'center' },
    };
    const customColumnsDefs: Record<string, any> = {
      id: {
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        minWidth: 80,
        maxWidth: 80,
      },
      code: { minWidth: 80, maxWidth: 80 },
      name: { minWidth: 140, maxWidth: 140 },
      description: { minWidth: 150, maxWidth: 150, tooltipField: 'description' },
      status: { minWidth: 100, maxWidth: 100 },
      lastDate: { minWidth: 160, maxWidth: 160 },
      lastGateway: { minWidth: 140, maxWidth: 140 },
      checkNocx: { cellRenderer: this.checkNocxCellRenderer, minWidth: 60, maxWidth: 60 },
      locationName: { tooltipField: 'locationName' },
      alerts: { cellRenderer: this.alertsCellRenderer },
      dateInstall: { cellRenderer: this.dateCellRenderer },
      dateOnline: { cellRenderer: this.dateCellRenderer },
      dateOffline: { cellRenderer: this.dateCellRenderer },
      dateAction: { cellRenderer: this.dateCellRenderer },
      groupsList: { cellRenderer: this.listCellRenderer },
    };
    const filterTypes: Record<string, string> = {
      lastDate: 'agDateColumnFilter',
      dateInstall: 'agDateColumnFilter',
      dateOnline: 'agDateColumnFilter',
      dateOffline: 'agDateColumnFilter',
      dateAction: 'agDateColumnFilter',
    };
    return (
      <div id="content" className="content">
        <div className="row">
          <div className="col-6 wdna-padding">
            <span>
              <b>{`Total Rows Selected: ${marked}`}</b>
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button type="button" className="btn btn-info" onClick={this.showModalUpdate}>
              <b>Update</b>
            </button>
          </div>
        </div>
        <div style={{ visibility: (showGrid ? 'visible' : 'hidden') }}>
          <Table
            data={data || []}
            alias={columnAlias}
            loading={loading}
            buttons={this.buttons}
            onAdd={this.onEdit}
            onPCustom={[
              this.onPCustom1,
              this.onPCustom2,
              this.onPCustom3
            ]}
            onEdit={this.onEdit}
            onGraph={this.onGraph}
            onList={this.onList}
            onList2={this.onList2}
            onDelete={this.onDelete}
            onCopy={this.onCopy}
            hiddenCols={columnsToHide1}
            rowDataUpdated={this.rowDataUpdated}
            customCellStyles={columnStyles}
            customColumnsDefs={customColumnsDefs}
            onGridReady={this.onGridReady}
            onSelectionChanged={this.countSelected}
            selection="multiple"
          />
        </div>

        <ContainerModal
          fullScreenButton={false}
          show={showSelector}
          title="Select new status"
          onClose={this.onClose1}
          modalClass="selector-modal"
          footerButtons={[
            {
              text: 'Save',
              className: 'btn btn-primary',
              onClick: this.onSave,
            },
          ]}
        >
          <Select2
            name="status"
            value={status}
            onChange={this.handleSelect}
            data={[
              { id: 'ON_AIR', text: 'on-air' },
              { id: 'PLANNED', text: 'planned' },
              { id: 'DISMANTLED', text: 'dismantled' },
            ]}
            options={{ placeholder: 'Status value' }}
            style={{ width: '80%' }}
          />
        </ContainerModal>

        <ContainerModal
          fullScreenButton={false}
          show={showNominal}
          title="Sensors Nominal PLan"
          modalClass="selector-modal-70"
          onClose={this.onClose2}
          footerButtons={[
            {
              text: 'OK',
              className: 'btn btn-primary',
              onClick: this.onClose2,
            },
          ]}
        >
          <Table
            data={data || []}
            alias={columnAlias}
            loading={loading}
            hiddenCols={columnsToHide2}
            customCellStyles={columnStyles}
            customColumnsDefs={customColumnsDefs}
            height="calc(70vh - 7px)"
            enableAdjustGridSize={false}
            filterTypes={filterTypes}
            pagination={false}
            showRowNumber
          />
        </ContainerModal>

        <ContainerModal
          fullScreenButton={false}
          show={showMigrateRegister}
          title="Migrate Register"
          onClose={this.onClose3}
          modalClass="selector-modal"
          footerButtons={[
            {
              text: 'OK',
              className: 'btn btn-primary',
              onClick: this.onClose3,
            },
          ]}
        >
          <div className="row">
            <div className="col-md-6">
              <label className="label">
                <b>Sensor 1:</b> &nbsp;
              </label>
              <span className="mandatory">
                <Select2
                  name="id_src"
                  value={_.defaultTo(id_src, '')}
                  onChange={this.handleChange}
                  data={data.map((item: SensorDO): DataSelect2 => {
                    return {
                      id: item.id,
                      text: `[${item.code}] ${item.name}`,
                    };
                  })}
                  options={{ placeholder: 'Select option' }}
                  style={{ width: '90%' }}
                  required
                />
              </span>
            </div>
            <div className="col-md-6">
              <label className="label">
                <b>Sensor 2:</b> &nbsp;
              </label>
              <span className="mandatory">
                <Select2
                  name="id_dst"
                  value={_.defaultTo(id_dst, '')}
                  onChange={this.handleChange}
                  data={data.map((item: SensorDO): DataSelect2 => {
                    return {
                      id: item.id,
                      text: `[${item.code}] ${item.name}`,
                    };
                  })}
                  options={{ placeholder: 'Select option' }}
                  style={{ width: '90%' }}
                  required
                />
              </span>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-6">
              <label className="label">
                <b>Date:</b> &nbsp;
              </label>
              <DatePicker
                icon
                hours={[]}
                dates={dates}
                showChangeModes
                mode={flatpickrMode}
                granularity={groupDateTime}
                iconClass="wdna-ico-icon-calendar"
                handleChanges={this.handleChangeDatePicker}
                style={{ width: '80%' }}
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12">
              <b>Result: </b><br />
              <textarea
                className="input-new"
                style={{ width: '85%', fontFamily: 'Inconsolata, monospace', fontSize: '14px' }}
                rows={15}
                cols={500}
                value={_.defaultTo(modalContent, '')}
                readOnly
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <button type="button" className="btn btn-success" onClick={(): void => { this.migrateRegisters().catch(() => { /* pass */ }); }}>
                <b>Execute</b>
              </button>
            </div>
          </div>
        </ContainerModal>
      </div>
    );
  }
}
